import React from "react";
import {
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import { TFunction } from "i18next";

interface IStageRulesDisplayProps {
    resultsToStageRule: CompleoShared.Assessments.IResultsToStageRule[];
    tLocal: TFunction;
}

const StageRulesDisplay = (props: IStageRulesDisplayProps) => {
    const { resultsToStageRule, tLocal } = props;

    if (!resultsToStageRule || resultsToStageRule.length === 0) {
        return null;
    }

    return (
        <Card elevation={0}>
            <CardContent>
                <Typography
                    variant="body1"
                    style={{
                        fontStyle: "italic",
                        fontWeight: 700
                    }}
                >
                    {tLocal("stageRules")}
                </Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ fontWeight: 700 }}>
                                    {tLocal("minimumScore")}
                                </TableCell>
                                <TableCell style={{ fontWeight: 700 }}>
                                    {tLocal("targetStage")}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {resultsToStageRule.map((rule, index) => (
                                <TableRow key={index}>
                                    <TableCell>{rule.minimumScore} %</TableCell>
                                    <TableCell>
                                        {rule.targetStage.label}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};

export default StageRulesDisplay;
